module.exports = __webpack_public_path__ + "static/media/RPLogo.0e1cf4a3.beta.png";